import { Slider as AntSlider } from 'antd';

import { NumberInput } from '../NumberInput';
import { Heading } from '../Typography';
import { BottomRow, Result, ResultWrapper, TopRow } from './style';
import { ResultProps, SliderProps } from './types';

export const Slider = ({
  onChange,
  stepSize,
  label,
  unit = '',
  valueLabel,
  value,
  size = 'middle',
  withInputField = false,
  min,
  status,
  ...rest
}: SliderProps) => {
  return (
    <>
      <TopRow>
        {!!label && <Heading level={4}>{label}</Heading>}
        {withInputField && (
          <NumberInput
            {...{
              onChange: number => onChange(number ?? min ?? 0),
              size: 'small',
              value,
              min,
              addonAfter: unit,
              style: { maxWidth: '40%' },
              status,
              ...rest,
            }}
          />
        )}
      </TopRow>
      <BottomRow>
        <AntSlider
          {...{
            step: stepSize,
            value,
            onChange: newValue => onChange(Number(newValue)),
            style: { width: '100%', marginLeft: 0 },
            ...rest,
          }}
        />
        {!withInputField && <ResultLabel {...{ size, value, unit, label: valueLabel }} />}
      </BottomRow>
    </>
  );
};

const ResultLabel = ({ value, unit, label, size = 'middle', style }: ResultProps) => {
  return (
    <ResultWrapper {...{ size, style }}>
      <Result>
        <span style={{ whiteSpace: 'nowrap' }}>{`${value} ${unit}`}</span>
      </Result>
      {!!label && <div>{label}</div>}
    </ResultWrapper>
  );
};
